<template>
  <b-card
    v-if="chartData"
    class="card-tiny-line-stats h-100"
    body-class="pb-50"
  >
    <b-card-header class="p-0">
      <b-card-title>
        <h6>
          Pendaftaran dan Pengguna Aktif {{ !enableRangePicker ? filterActive.title : '' }}
        </h6>
      </b-card-title>
      <div
        v-if="enableRangePicker"
      >
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="CalendarIcon" />
          </b-input-group-prepend>
          <flat-pickr
            v-model="rangeDate"
            class="form-control"
            :config="{ mode: 'range'}"
            @on-close="handleDateChange"
          />
        </b-input-group>
      </div>
      <b-dropdown
        v-else
        no-caret
        right
        :text="filterActive.title"
        variant="transparent"
        class="chart-dropdown"
        toggle-class="p-50"
        size="sm"
      >
        <b-dropdown-item
          v-for="(item, index) in filterList"
          :key="`list-filter-${index}`"
          @click="getChartUserRegistered({interval: item.value, type: type})"
        >
          {{ item.title }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>
    <!-- chart -->
    <b-card-body class="p-0">
      <vue-apex-charts
        v-if="!isLoading"
        :options="chartOptions"
        :height="chartHeight"
        :series="chartDatas"
      />

      <div
        v-else
        class="text-center"
      >
        <b-spinner
          variant="primary"
          label="Spinning"
          class="mt-2"
        />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BSpinner,
  BDropdown,
  BDropdownItem,
  BInputGroup,
  BInputGroupPrepend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,

    BCardBody,
    VueApexCharts,
    BSpinner,
    flatPickr,
    BDropdown,
    BDropdownItem,
    BInputGroup,
    BInputGroupPrepend,
  },
  props: {
    enableRangePicker: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'buyer',
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    chartHeight: {
      type: [Number, String],
      default: 200,
    },
  },
  data() {
    return {
      rangeDate: '',
      chartOption: {
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        fill: {
          type: 'solid',
          opacity: [0.35, 0.35],
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Montserrat',
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: '0px',
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: [{
          show: false,
        }, {
          show: false,
        }, {
          show: false,
          opposite: true,
        }],

      },
    }
  },
  computed: {
    ...mapState('user', ['filterList', 'filterActive']),
    chartDatas() {
      return [
        {
          name: 'User Aktif',
          type: 'area',
          data: this.chartData.map(el => ({ x: el.date, y: el.login_count })),
        },
        {
          name: 'User Registration',
          type: 'area',
          data: this.chartData.map(el => ({ x: el.date, y: el.registration_count })),
        },
        {
          name: 'Registration Total',
          type: 'line',
          data: this.chartData.map(el => ({ x: el.date, y: el.registration_total })),
        },
      ]
    },
    chartOptions() {
      return {
        ...this.chartOption,
        tooltip: {
          shared: true,
          x: {
            formatter: val => {
              const date = new Date(val)
              const options = this.isMonthly
                ? { year: 'numeric', month: 'long' }
                : { day: 'numeric', month: 'short', year: 'numeric' }

              // Format ID date
              return new Intl.DateTimeFormat('id-ID', options).format(date)
            },
          },
        },
      }
    },
    isMonthly() {
      // Detect monthly mode if data gap > 20 days
      if (!this.chartData || this.chartData.length < 2) return false

      const first = new Date(this.chartData[0].date)
      const second = new Date(this.chartData[1].date)
      const diffTime = Math.abs(second - first)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      return diffDays > 20
    },
  },
  created() {
    const end = new Date()
    const start = new Date()
    start.setFullYear(start.getFullYear() - 1)

    // Format to YYYY-MM-DD
    const formatDate = date => date.toISOString().split('T')[0]

    this.rangeDate = `${formatDate(start)} to ${formatDate(end)}`
  },
  methods: {
    ...mapActions('user', ['getUserGrowth', 'getChartUserRegistered']),
    handleDateChange(selectedDates, dateStr) {
      if (dateStr.includes('to')) {
        const [start, end] = dateStr.split(' to ')
        this.getChartUserRegistered({
          startDate: start,
          endDate: end,
          type: this.type,
        })
      }
    },
  },
}
</script>
